export const BASE_URL = "https://openlibrary.org";
export const API_PREFIX = "";
